(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["drop-01-product"]) return;
  try {
    
  if (!customElements.get('mbs-stage')) {
    class MbsStage extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('.mbs-stage__tab'));
        this.panels = Array.from(this.querySelectorAll('.mbs-stage__panel'));
        this.tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => this.select(tab.dataset.key, false));
          tab.addEventListener('keydown', (event) => {
            let next = null;
            if (event.key === 'ArrowRight') next = this.tabs[(i + 1) % this.tabs.length];
            if (event.key === 'ArrowLeft') next = this.tabs[(i - 1 + this.tabs.length) % this.tabs.length];
            if (event.key === 'Home') next = this.tabs[0];
            if (event.key === 'End') next = this.tabs[this.tabs.length - 1];
            if (next) {
              event.preventDefault();
              this.select(next.dataset.key, true);
            }
          });
        });
      }

      select(key, focus) {
        this.dataset.view = key;
        this.tabs.forEach((tab) => {
          const on = tab.dataset.key === key;
          tab.setAttribute('aria-selected', String(on));
          tab.tabIndex = on ? 0 : -1;
          if (on && focus) tab.focus();
        });
        this.panels.forEach((panel) => {
          const on = panel.dataset.key === key;
          panel.hidden = !on;
          if (on) panel.querySelectorAll('img[loading="lazy"]').forEach((img) => (img.loading = 'eager'));
        });
      }
    }
    customElements.define('mbs-stage', MbsStage);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drop-01-rail"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mbs-rail')) {
    class MbsRail extends HTMLElement {
      connectedCallback() {
        this.scroller = this.querySelector('.mbs-rail__scroller');
        this.bar = this.querySelector('.mbs-rail__progress span');
        this.buttons = this.querySelectorAll('.mbs-rail__btn');
        if (!this.scroller) return;

        this.onScroll = () => this.update();
        this.scroller.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll);
        this.buttons.forEach((btn) =>
          btn.addEventListener('click', () => {
            const dir = Number(btn.dataset.dir || 1);
            const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            this.scroller.scrollBy({
              left: dir * this.scroller.clientWidth * 0.8,
              behavior: reduce ? 'auto' : 'smooth',
            });
          })
        );

        this.classList.add('is-ready');
        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver(
            (entries) => {
              if (entries.some((e) => e.isIntersecting)) {
                this.classList.add('is-visible');
                this.io.disconnect();
              }
            },
            { threshold: 0.15 }
          );
          this.io.observe(this);
        } else {
          this.classList.add('is-visible');
        }
        this.update();
      }

      disconnectedCallback() {
        this.scroller?.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        this.io?.disconnect();
      }

      update() {
        const s = this.scroller;
        const max = s.scrollWidth - s.clientWidth;
        const ratio = s.scrollWidth ? s.clientWidth / s.scrollWidth : 1;
        const progress = max > 0 ? s.scrollLeft / max : 0;
        if (this.bar) {
          this.bar.style.width = `${Math.max(ratio, 0.08) * 100}%`;
          this.bar.style.transform = `translateX(${progress * (1 / Math.max(ratio, 0.08) - 1) * 100}%)`;
        }
        const [prev, next] = this.buttons;
        if (prev) prev.disabled = s.scrollLeft <= 2;
        if (next) next.disabled = s.scrollLeft >= max - 2;
      }
    }
    customElements.define('mbs-rail', MbsRail);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
